import { BackArrow } from "../../../assets/icons-components/Icons";
import { onKeyActivate } from "../../../utils/a11y";

const RANGE_OPTIONS = ["10s", "30s", "1m", "10m", "1h", "All"];

const SessionGraphHeader = ({ title, onBack, activeRange, onRangeSelect }) => (
  <div className="graph_header">
    <div className="graph_header_left">
      <div
        className="graph_header_left_arrow"
        onClick={onBack}
        onKeyDown={onKeyActivate(onBack)}
        role="button"
        tabIndex={0}
      >
        <BackArrow />
        <h3>{title || "-"}</h3>
      </div>
    </div>
    <div className="graph_header_right">
      <div className="graph_header_right_cont">
        {RANGE_OPTIONS.map((range) => (
          <button
            type="button"
            key={range}
            className={`graph_header_right_cont_normal ${
              activeRange === range ? "active" : ""
            }`}
            onClick={() => onRangeSelect(range)}
          >
            {range}
          </button>
        ))}
      </div>
    </div>
  </div>
);

export default SessionGraphHeader;
